import Hashes from './assets/js/hashes'

/**
 * cookie操作
 */
export const Cookie = {
    set: function (name, value) {
        window.document.cookie = name + "=" + value;
    },
    get: function (name) {
        var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    },
    delete: function (name) {
        this.set(name, '', -1);
    }
};


export const setWebViewJavascriptBridge = (cb) => {
    function initWebViewJavascriptBridge(){
        if(window.WebViewJavascriptBridge && WebViewJavascriptBridge.init && !WebViewJavascriptBridge._messageHandler){
            // console.log('init--1');
            WebViewJavascriptBridge.init(function(message, responseCallback) {
                // console.log('JS got a message', message);
                var data = {
                    'Javascript Responds': '测试中文!'
                };
                // console.log('JS responding with', data);
                responseCallback(data);
            });
        }
    }

    if (window.WebViewJavascriptBridge) {
        initWebViewJavascriptBridge();
        // console.log('initBefore--');
        return cb(window.WebViewJavascriptBridge);
    }
    document.addEventListener('WebViewJavascriptBridgeReady', function() {
        initWebViewJavascriptBridge();
        cb(WebViewJavascriptBridge);
        // console.log('initBefore--',WebViewJavascriptBridge);
    }, false);
    initWebViewJavascriptBridge();
    if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(cb); }
    window.WVJBCallbacks = [cb];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function() { document.documentElement.removeChild(WVJBIframe); }, 0);

};

export const Bridge = (web,native) => {
    // console.log(window.navigator);
    if(window.navigator.userAgent && window.navigator.userAgent.indexOf('zhaoonline') > -1 ){
        if(native && typeof native == 'function'){
            setWebViewJavascriptBridge(function(bridge){
                // console.log('执行bridge',bridge);
                native(bridge);
            });
        }
    }else{
        if(web && typeof web == 'function') web();
    }
};


/**
 * 加密算法
 */
export const Authentication = function(appId,key,deviceId,HttpMothod, HttpPath) {
    var SecretAccessKey = key;
    var SHA1 = new Hashes.SHA1(),
    stringToSign = HttpMothod.toUpperCase() + '\n\n' + HttpPath + '\n' + deviceId,
    signature = SHA1.b64_hmac(SecretAccessKey, stringToSign);
    return 'ZHAO ' + appId + ':' + signature;
};


/**
 * 获取app类型
 */
export const getPlatform = () => {
    var result = {
        TYPE: '',
        APP: ''
    }
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        result.TYPE = 'ios'
    } else if (/(Android)/i.test(navigator.userAgent)) {
        result.TYPE = 'android'
    } else {
        result.TYPE = 'pc'
    }
    if (window.navigator.userAgent.indexOf('zhaoonline') > -1){
        result.APP = 'zhaoonline'
    } else  if (window.navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1) {
        result.APP = 'weixin'
    } else  if (window.navigator.userAgent.toLowerCase().indexOf('weibo') > -1) {
        result.APP = 'weibo'
    } else {
        result.APP = 'default'
    }
    return result
}



/**
 * 获取设备
 */
export const getDevice = function(needle){
    // alert(navigator.userAgent);
    var find = function(needle){return navigator.userAgent.toLowerCase().indexOf(needle) !== -1;};
    var device = {
        ios : function () {
            return this.iphone() || this.ipod() || this.ipad();
        },
        iphone : function () {
            return !this.windows() && find('iphone');
        },
        ipod : function () {
            return find('ipod');
        },
        ipad : function () {
            return find('ipad');
        },
        android : function () {//设备
            return !this.windows() && find('android');
        },
        androidPhone : function () {//android 手机
            return this.android() && find('mobile');
        },
        androidTablet : function () {//android 平板
            return this.android() && !find('mobile');
        },
        blackberry : function () { //黑莓
            return find('blackberry') || find('bb10') || find('rim');
        },
        blackberryPhone : function () {
            return this.blackberry() && !find('tablet');
        },
        blackberryTablet : function () {
            return this.blackberry() && find('tablet');
        },
        windows : function () {
            return find('windows');
        },
        windowsPhone : function () {
            return this.windows() && find('phone');
        },
        windowsTablet : function () {
            return this.windows() && (find('touch') && !this.windowsPhone());
        },
        fxos : function () { //Firefox
            return (find('(mobile;') || find('(tablet;')) && find('; rv:');
        },
        fxosPhone : function () {
            return this.fxos() && find('mobile');
        },
        fxosTablet : function () {
            return this.fxos() && find('tablet');
        },
        meego : function () { //诺基亚
            return find('meego');
        },
        cordova : function () {
            return window.cordova && location.protocol === 'file:';
        },
        nodeWebkit : function () {
            return typeof window.process === 'object';
        },
        mobile : function () {
            return this.androidPhone() || this.iphone() || this.ipod() || this.windowsPhone() || this.blackberryPhone() || this.fxosPhone() || this.meego();
        },
        tablet : function () {
            return this.ipad() || this.androidTablet() || this.blackberryTablet() || this.windowsTablet() || this.fxosTablet();
        },
        desktop : function () {
            return !this.tablet() && !this.mobile();
        }
    };
    return device[needle]();
}
/**
 * 获取url参数
 */
export const getQueryString = (name) => {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]); return null;
}
/**
 * 获取url参数
 */
export const getUrlQuery = (name) => {
    return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
}
/**
 * 获取屏幕尺寸
 */
export const getViewData = () => {
    return {
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight
    }
}



// WEBPACK FOOTER //
// ./src/utils.js